<div class="animal-group-navigation" *ngIf="animalGroupId >= 0" data-test="animal-group-navigation">
  <nav mat-tab-nav-bar color="accent" [tabPanel]="tabPanel" [mat-stretch-tabs]="false">
    <a mat-tab-link [routerLink]="['/animal-group', animalGroupId]" [active]="isGeneral$ | async">
      {{ 'animal-group.navigation.general' | translate }}
    </a>

    <a
      mat-tab-link
      [routerLink]="['/animal-group', animalGroupId, 'feedadvice-applications']"
      [active]="isFeedAdviceApplications$ | async"
      data-test="animal-group-navigation__feedadvice"
    >
      {{ 'animal-group.navigation.feedadvice-applications' | translate }}
    </a>

    <ng-container *ngIf="hasObservations$ | async">
      <a
        mat-tab-link
        [routerLink]="['/animal-group', animalGroupId, 'observations']"
        [active]="isObservations$ | async"
        data-test="animal-group-navigation__observations"
      >
        {{ 'animal-group.navigation.observations' | translate }}
      </a>
    </ng-container>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
